<template>
  <div>
    <!-- Tabs -->
    <div class="tabs flex border-b mb-4">
      <button
        class="py-2 -mb-px font-semibold border-b-2 px-4"
        :class="{
          'border-custom-yellow text-custom-blue': currentTab === 'diagnosis',
          'text-gray-500': currentTab !== 'diagnosis',
        }"
        @click="currentTab = 'diagnosis'"
      >
        Diagnosis
      </button>
    </div>

    <div
      v-if="currentTab === 'diagnosis' && (state === 'create' || state === 'edit')"
      class="grid grid-cols-1 gap-4"
    >
      <div class="grid grid-cols-1 gap-6">
        <div class="mb-4">
          <h3 class="text-sm font-semibold text-gray-600">Doctor Notes:</h3>
          <textarea
            :disabled="state === 'view'"
            v-model="diagnosisForm.findings"
            rows="4"
            placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2"
          ></textarea>
        </div>
        <div class="mb-4">
          <h3 class="text-sm font-semibold text-gray-600">Final Doctor Diagnosis:</h3>
          <multiselect
            class="z-999 mt-4"
            v-model="diagnosisForm.diagnosis"
            :disabled="state === 'view'"
            :options="diagnosis"
            :multiple="true"
            :searchable="true"
            :loading="isLoading"
            :internal-search="false"
            @search-change="searchDiagnosis"
            placeholder="Type to search diagnosis and select"
            label="name"
            track-by="id"
          ></multiselect>
        </div>
      </div>
    </div>
    <div v-if="state === 'view'" class="grid grid-cols-1 gap-6">
      <div class="mb-4">
        <h3 class="text-sm font-semibold text-gray-800">Findings:</h3>
        <p class="text-sm text-gray-600">{{ existingFindings || "-" }}</p>
      </div>
      <div class="mb-4">
        <h3 class="text-sm font-semibold text-gray-800">Final Doctor Diagnosis:</h3>
        <p class="text-sm text-gray-600">
          <span v-for="(diag, index) in existingFinalDiagnosis" :key="index">
            {{ diag.diagnosis?.name || "-" }}
            <span v-if="index < existingFinalDiagnosis.length - 1">, </span>
          </span>
          <span v-if="!existingFinalDiagnosis.length">-</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/services/api";
import Multiselect from "vue-multiselect";

export default {
  name: "DiagnosisTab",
  components: {
    Multiselect,
  },
  props: {
    state: {
      type: String,
      required: true,
    },
    visitId: {
      type: String,
      required: true,
    },
    existingFindings: {
      type: String,
      default: "",
    },
    existingFinalDiagnosis: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentTab: "diagnosis",
      diagnosisForm: {
        findings: "",
        diagnosis: [],
      },
      isLoading: false,
      diagnosis: [],
    };
  },
  watch: {
    existingFindings: {
      handler(existingFindings) {
        this.diagnosisForm.findings = existingFindings || "";
      },
      immediate: true,
      deep: true,
    },
    existingFinalDiagnosis: {
      handler(existingDiagnosis) {
        if (existingDiagnosis?.length > 0) {
          this.diagnosis = existingDiagnosis.map(d => d.diagnosis).filter(d => d);
          this.diagnosisForm.diagnosis = [...this.diagnosis];
        } else {
          this.diagnosis = [];
          this.diagnosisForm.diagnosis = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    submitDiagnosis() {
      return { ...this.diagnosisForm };
    },
    async searchDiagnosis(searchString) {
      try {
        if (searchString.length < 3) {
          return;
        }
        this.isLoading = true;
        const payload = { name: searchString };
        const response = await apiClient.searchDiagnosis(payload);
        this.isLoading = false;
        if (response.success) {
          this.diagnosis = response.data;
        } else {
          this.$toast.error("Unable to search diagnosis.");
        }
      } catch (error) {
        this.isLoading = false;
        this.$toast.error("Unable to search diagnosis, please check your internet connection.");
      }
    },
  },
};
</script>

<style lang="css" scoped>
.multiselect__input,
.multiselect__single {
  height: 30px !important;
  padding: 5px !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>